export const BACKEND_URL = process.env.REACT_APP_BACKEND_DOMAIN + "/wods/";
export const REGISTER_USER = BACKEND_URL + "register";
export const LOGIN_USER = BACKEND_URL + "login";
export const LOGOUT_USER = BACKEND_URL + "logout";
export const DELETE_ACCOUNT_REQUEST = BACKEND_URL + "account/delete/request";
export const DELETE_USER_ACCOUNT = BACKEND_URL + "account/delete";
export const BLOCK_USER = BACKEND_URL + "user/block";
export const VERIFY_EMAIL = BACKEND_URL + "user/verify/email";
export const GET_USER = BACKEND_URL + "user/get";
export const GENERATE_WOD = BACKEND_URL + "workout/create";
export const SAVE_WOD = BACKEND_URL + "workout/save";
export const GET_WEIGHTLIFTING_STANDINGS =
  BACKEND_URL + "standings/weightlifting";
export const GET_GYMNASTICS_STANDINGS = BACKEND_URL + "standings/gymnastics";
export const GET_CARDIO_STANDINGS = BACKEND_URL + "standings/cardio";
export const EXERCISES = BACKEND_URL + "exercises/list";
export const GET_EXCLUDED_EXERCISES = BACKEND_URL + "exercises/excluded";
export const EXERCISE_CATEGORIES = BACKEND_URL + "exercise/categories/";
export const EXERCISE_FILTER = BACKEND_URL + "exercises/filter";
export const USERS_STATISTICS = BACKEND_URL + "getuserstatistics/";
export const UPDATE_USERS_LIFTS = BACKEND_URL + "updateuserslifts/";
export const DELETE_WOD = BACKEND_URL + "workout/delete";
export const SET_WOD_SCORE = BACKEND_URL + "workout/score";
export const GET_WOD = BACKEND_URL + "workout/get/";
export const GET_ACHIEVEMENTS = BACKEND_URL + "achievements";
export const GET_USER_ACHIEVEMENTS = BACKEND_URL + "user/achievements";
export const GET_WORKOUT_LEADERBOARD = BACKEND_URL + "workout/leaderboard";
export const GET_WODS_COMMENTS = BACKEND_URL + "comments/get/";
export const POST_COMMENT = BACKEND_URL + "comment/add";
export const GET_USERS_WODS = BACKEND_URL + "workouts";
export const GET_PUBLIC_WODS = BACKEND_URL + "workouts/public";
export const CHECK_USERS_SESSION = BACKEND_URL + "check/";
export const RECOVER_PASSWORD = BACKEND_URL + "user/password/recover";
export const RESET_PASSWORD = BACKEND_URL + "user/password/reset";
export const UPDATE_PROFILE_PICTURE = BACKEND_URL + "media/upload";
export const UPDATE_PROFILE = BACKEND_URL + "user/profile/update";
export const GET_USER_LIFTS = BACKEND_URL + "athlete/abilities/lifts";
export const GET_USER_GYMNASTICS = BACKEND_URL + "athlete/abilities/gymnastics";
export const GET_USER_CARDIO = BACKEND_URL + "athlete/abilities/cardio";
export const UPDATE_USERS_GYMNASTICS = BACKEND_URL + "updateusersgymnastics/";
export const UPDATE_USERS_CARDIO = BACKEND_URL + "updateuserscardio/";
export const GET_USERS_WORKOUT_SCORES = BACKEND_URL + "userscores/workout/";
export const UPDATE_USERS_ABILITIES = BACKEND_URL + "updateuserabilities/";
export const GET_USERS_TRAINING = BACKEND_URL + "getuserstraining/";
export const GET_COUNTRIES = BACKEND_URL + "countries";
export const GET_WORKOUT_TYPES = BACKEND_URL + "workout/types";
export const GET_WORKOUTS_SCORE = BACKEND_URL + "workout/scores/";
export const GET_WORKOUTS_BY_TYPE = BACKEND_URL + "workouts/type/";
export const GET_WORKOUTS_BY_STATUS = BACKEND_URL + "workouts/status/";
export const GET_WORKOUTS_BY_ACTIVITY = BACKEND_URL + "workouts/activity/";
export const GET_WORKOUTS_BY_RESULT = BACKEND_URL + "workouts/result/";
export const GET_WORKOUT_STRUCTURES = BACKEND_URL + "structures";
export const GET_WORKOUT_BY_TYPE_STATS = BACKEND_URL + "stats/workout/types/";
export const GET_WORKOUT_BY_CATEGORY_STATS =
  BACKEND_URL + "stats/workout/categories/";
export const INSERT_BIOMETRIC_DATA = BACKEND_URL + "user/biometrics/save";
export const GET_USER_BIOMETRICS = BACKEND_URL + "user/biometrics";
export const COMPLETE_PROFILE = BACKEND_URL + "user/profile/complete";
export const SHARE_WORKOUT = BACKEND_URL + "workout/share";
export const GET_WORKOUT_STATS = BACKEND_URL + "workout/statistics/";
export const CHECK_USER_STREAK = BACKEND_URL + "user/streak/check";
export const GET_USERS_WORKOUT_PB = BACKEND_URL + "workout/user/pb";
export const LIKE_WORKOUT = BACKEND_URL + "user/workout/like";
export const SAVE_SETTINGS = BACKEND_URL + "user/settings/save";
export const GET_SETTINGS = BACKEND_URL + "user/settings";
export const GET_ATHLETE_PROFILE = BACKEND_URL + "athlete/profile/";
export const EDIT_ABILITIES = BACKEND_URL + "athlete/abilities/edit";
export const GET_PERFORMANCE_EXERCISES = BACKEND_URL + "exercises/performance/";
export const GET_EXERCISE_PROGRESS =
  BACKEND_URL + "athlete/exercise/performance";
export const GET_EXERCISE_STATS =
  BACKEND_URL + "standings/exercise/performance";
export const GET_WORKOUT_PERFORMANCE = BACKEND_URL + "workouts/performance/";
export const CHECK_ENTRY_POSTED_TODAY =
  BACKEND_URL + "entry/insert/today/check";
export const GET_WORKOUT_PERFORMANCE_STATS =
  BACKEND_URL + "statistics/workout/";
export const GET_EMOM_DETAILS = BACKEND_URL + "statistics/workout/emom/";
export const GET_WEIGHTS = BACKEND_URL + "weights";
export const GET_SCORE_RANGE = BACKEND_URL + "statistics/workout/score/range/";
export const GET_USERS_NOTIFICATIONS = BACKEND_URL + "notifications/user";
export const READ_NOTIFICATION = BACKEND_URL + "notifications/read";
export const GET_SCALING = BACKEND_URL + "scaling";
export const GET_WEEKLY_WORKOUT = BACKEND_URL + "wow/get/";
export const GET_MOST_PERFORMED_WORKOUT = BACKEND_URL + "workout/trending";
export const GET_WORKOUT_PERFORMANCE_STATISTICS =
  BACKEND_URL + "statistics/workout/progress/";
export const GET_ALL_USERS = BACKEND_URL + "admin/users/all";
export const GET_USER_ACTIVITY = BACKEND_URL + "user/weekly/activity/";
export const GET_WOW_STATISTICS = BACKEND_URL + "wow/statistics";
export const GET_WOW_PLACES = BACKEND_URL + "wow/places";
export const GET_RECENT_EXERCISE_PROGRESS =
  BACKEND_URL + "user/exercise/recent/progress/type/";
export const VALIDATE_CAPTCHA = BACKEND_URL + "validate/captcha";
export const HAS_USER_ACCESS_TO_WORKOUT = BACKEND_URL + "workout/user/access/";
export const GET_DEVICE_STATISTICS = BACKEND_URL + "admin/device/stats";
export const GET_ATHLETES_BY_FILTERS = BACKEND_URL + "challenge/athletes/get";
export const CHALLENGE_ATHLETE = BACKEND_URL + "challenge/create";
export const ANSWER_CHALLENGE = BACKEND_URL + "challenge/answer";
export const GET_ATHLETE_CHALLENGE_STATISTICS =
  BACKEND_URL + "athlete/challenge/statistics";
export const GET_ATHLETE_CHALLENGES = BACKEND_URL + "challenge/get";
export const GET_ATHLETE_VERSUS_STATS = BACKEND_URL + "athlete/versus/";
export const DELETE_COMMENT = BACKEND_URL + "comment/delete/";
export const GET_PRESIGNED_URL = BACKEND_URL + "media/presigned-url";
export const CONFIRM_UPLOAD = BACKEND_URL + "media/confirm";
